import { IResourceComponentsProps } from '@refinedev/core';
import { AntdShowInferencer } from '@refinedev/inferencer/antd';

export const CategoryShow: React.FC<IResourceComponentsProps> = () => {
  return <AntdShowInferencer />;
};
